// Model tier categories for the "By Model" stacked breakdown — mirrors the tier
// labels configured per-agent in Organisation Management's AI Models modal
// (pages/OrgMgmt/aiModelsAllocation.js MODEL_TIERS: High/Medium/Low). Colors reuse
// the app's existing High/Medium/Low semantic (theme/foundations/colors.js
// colors.highMediumLow, used by the AI Dashboard confidence waffle) rather than the
// qualitative task-type palette, since these ARE the same three named levels shown
// elsewhere in the app.
export const MODEL_TIER_TYPES = [
  { key: "High", label: "High", color: "#25C469" },
  { key: "Medium", label: "Medium", color: "#FFD008" },
  { key: "Low", label: "Low", color: "#FC2B18" },
];

export const MODEL_TIER_KEYS = MODEL_TIER_TYPES.map((t) => t.key);

export function getModelTierColor(key) {
  return MODEL_TIER_TYPES.find((t) => t.key === key)?.color || "#A0AEC0";
}
